// https://switcheroo.atlassian.com/ui/gates/21254a40-1d57-4de4-9980-f9e2f7dbcb17/key/rovo-ext_left_nav_cta_filter
export const ROVO_EXTENSION_LEFT_NAV_CTA_FILTER_GATE = 'rovo-ext_left_nav_cta_filter';
// https://switcheroo.atlassian.com/ui/gates/4bb14a49-572d-4f41-99b8-3d8ca5260adc/key/rovo-ext_left_nav_rovo_extension_cta
export const ROVO_EXTENSION_LEFT_NAV_CTA_EXPERIMENT = 'rovo-ext_left_nav_rovo_extension_cta';
